import { Box } from '@looker/components';
import { type FC, useMemo } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import { useFilters } from '../../../../../../hooks/useFilters';
import type { Filter } from '../../../../../../stores/filters';
import AdvancedFilters from '../../AdvancedFilters';

const filterName = 'extend_with_facility_affiliation';

export const AffiltiationGraph: FC<ICustomFilter> = () => {
  const { filters } = useFilters();
  const filtersList = useMemo(() => (filters ? (Object.values(filters) as Array<Filter>) : []), [filters]);

  const affiliationGraphFilter = filtersList.find((filter) => filter.filterName === filterName);

  return (
    <Box>
      {affiliationGraphFilter?.expression === 'Yes' && (
        <AdvancedFilters displayHintText={false} context="extend_with_facility_affiliation" />
      )}
    </Box>
  );
};
